import { useEffect } from "react";

/**
 * Sets the document title via direct assignment in a useEffect.
 */
export function useTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
